/** Canonical public site URL — used for shareable links and document branding. */
export const SITE_URL = "https://finendra.com";
export const SITE_DOMAIN = "finendra.com";

/** Build an absolute URL on the production domain, regardless of preview host. */
export function siteUrl(path: string): string {
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

/** Calendly booking URL for consultation scheduling. */
export const CALENDLY_URL =
  (typeof import.meta !== "undefined" && import.meta.env?.["VITE_CALENDLY_URL"]) ||
  "https://calendly.com/connect-finendra";

/** Primary contact and support email address. */
export const CONTACT_EMAIL = "connect@finendra.com";
